import {Component, input, model} from '@angular/core';
import {FermeturePeriodePlanProdErreurDTO} from '../../../core/dtos/client/fermeture/fermeture-periode-plan-prod-erreur-dto';

@Component({
  selector: 'yo-fermeture-erreur-periode',
  templateUrl: './fermeture-erreur-periode.component.html',
  standalone: false
})
export class FermetureErreurPeriodeComponent {

  visible = model(false);
  erreurs = input<FermeturePeriodePlanProdErreurDTO[]>([]);
}
